/* eslint-disable import/no-cycle */
import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";

import { FilterModel } from "../../../../../domain/models/enum";
import {
  TakerModel,
  TakerResponseModel,
} from "../../../../../domain/models/taker";

import { makeRemoteTaker } from "../../../../../main/factories/usecases/taker/remote-taker-factory";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import { CountryProps } from "../../../../../domain/models/address.model";

import toastUtils from "../../../../../utils/ToastUtils";
import ButtonComponent from "../../../../components/button";
import DataGrid from "../../../../components/datagrid";
import FormFactory from "../../../../components/form-factory";
import {
  fieldsGrid,
  FieldsTomador,
  FilterFields,
} from "../../foreign-note/form/fields";
import ChooseModal from "../../../../components/modals/choose-modal";

import { theme } from "../../../../styles/theme";
import { CustomGrid } from "../../foreign-note/form/styles";
import { FormFactoryContainer } from "./styles";
import { useAuthGlobal } from "../../../../../contexts/auth-context/auth-context";

type PageProps = {
  setCurrentNote: (prev: any) => void;
  currentNote: any;
  selectedDeveloperId?: number;
  lockForeign?: boolean;
};

const generateFilter = (values: any): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      if (el === "developer") {
        return `${el}=${values[el]}`;
      }

      return el;
    })
    .join(",");

const isSmallScreen = window.innerWidth < 768;

const TomadorComponent: React.FC<PageProps> = ({
  setCurrentNote,
  currentNote,
  selectedDeveloperId,
  lockForeign,
}) => {
  const history = useHistory();
  const auth = useAuthGlobal();

  const [confirm, setConfirm] = React.useState<TakerModel | null>();
  const [takerCreatedOpUpdated, setTakerCreatedOrUpdated] =
    React.useState<TakerModel | null>();
  const [selected, setSelected] = React.useState<TakerModel | null>();
  const [list, setList] = React.useState<TakerResponseModel>();
  const [loading, setLoading] = React.useState<boolean>();
  const [show, setShow] = React.useState<boolean>();
  const [showGrid, setShowGrid] = React.useState<boolean>();
  const [params, setParams] = React.useState<FilterModel>({});
  const [countries, setCountries] = React.useState<CountryProps[]>([]);

  React.useEffect(() => {
    (async () => {
      try {
        const data = await makeRemoteAddresss().loadCountries();
        setCountries(data);
      } catch (error) {
        setCountries([]);
      }
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      let developerId = auth?.user?.developerResponseDTO?.id;
      if (selectedDeveloperId && auth.user?.roles?.find((e: any) => e.authority === "SUPERADMIN")) {
        developerId = selectedDeveloperId;
      }
      setLoading(true);
      const takerList = await makeRemoteTaker().load({
        ...params,
        filters: generateFilter({
          ...params?.filters,
          developer: developerId,
        }),
      });
      setList(takerList);
      setLoading(false);
    })();
  }, [params, takerCreatedOpUpdated, auth?.user?.developerResponseDTO?.id, auth?.user?.roles, selectedDeveloperId]);

  const onHide = (): void => {
    setShow(false);
  };

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));
  };

  const handleSubmit = async (values: any, actions: any): Promise<void> => {
    try {
      actions.setSubmitting(true);
      const isForeign = lockForeign || values?.isForeignTaker === "true";

      const buildForeignAddress = (): any => {
        const countryId = values?.codeCountry;
        const country = countries.find(
          (c) => c?.isoCode === countryId,
        );
        return {
          codeCountry: countryId || undefined,
          descriptionCountry: country?.name,
          descriptionCity: values?.descriptionCity,
          state: values?.state,
          place: values?.address,
          district: values?.district,
          number: values?.number,
          city: values?.descriptionCity,
          complement: values?.complement,
        };
      };

      const buildNationalAddress = (): any => ({
        place: values?.address,
        number: values?.number,
        district: values?.district,
        city: values?.city,
        state: values?.state,
        complement: values?.complement,
        zipCode: values?.zipCode,
      });

      const buildForeignTaker = (): any => ({
        isForeignTaker: true,
        socialReason: values?.socialReason,
        email: values?.email,
        codeForeign: values?.hasNif === "true" ? values?.codeForeign : undefined,
        naoNif: values?.hasNif === "false" ? values?.naoNif : undefined,
      });

      const buildNationalTaker = (): any => ({
        isForeignTaker: false,
        documentNumber: values.documentNumber,
        documentTypeEnum: values.documentTypeEnum,
        email: values?.email,
        municipalRegistration: values?.municipalRegistration || "",
        socialReason: values?.socialReason,
        stateRegistration: values?.stateRegistration,
        taxSubstitute: values?.taxSubstitute === "true",
      });

      if (selected?.id) {
        const baseAddress = isForeign
          ? buildForeignAddress()
          : buildNationalAddress();
        const takerData = await makeRemoteTaker().update(selected?.id, {
          address: { id: selected?.address?.id, ...baseAddress },
          id: selected?.id,
          ...(isForeign ? buildForeignTaker() : buildNationalTaker()),
        });
        setConfirm(takerData);
        setTakerCreatedOrUpdated(takerData);
      } else {
        let developerId = auth?.user?.developerResponseDTO?.id;
        if (selectedDeveloperId && auth?.user?.roles.find((e: any) => e.authority === "SUPERADMIN")) {
          developerId = selectedDeveloperId;
        }
        const baseAddress = isForeign
          ? buildForeignAddress()
          : buildNationalAddress();
        const takerData = await makeRemoteTaker().create({
          address: baseAddress,
          ...(isForeign ? buildForeignTaker() : buildNationalTaker()),
          developerId,
        });
        setConfirm(takerData);
        setTakerCreatedOrUpdated(takerData);
      }
      toastUtils.showMessage({
        type: "success",
        message: "Salvo com Sucesso",
      });
      actions.setSubmitting(false);
    } catch (error: any) {
      actions.setSubmitting(false);
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar informações:${error?.detail || error?.userMessage
          }`,
      });
    }
  };

  return (
    <div className="w-50 d-flex justify-content-center mb-4 taker-container">
      <div className="w-50">
        <ButtonComponent
          type="button"
          title={
            currentNote?.taker?.socialReason
              ? currentNote?.taker?.socialReason
              : "Selecionar Tomador"
          }
          color={theme.colors.white}
          backgroundColor={theme.colors.primary}
          onClick={() => setShowGrid(true)}
        />
      </div>
      <div className="ms-2 w-50">
        <ButtonComponent
          type="button"
          title="+ Novo Tomador"
          color={theme.colors.blue100}
          backgroundColor={theme.colors.darkBlue}
          onClick={() => setShow(true)}
          border
        />
      </div>
      <Dialog
        header="Adicionar Tomador:"
        visible={!!show}
        style={{ width: isSmallScreen ? "90vw" : "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => onHide()}
      >
        <FormFactoryContainer>
          <FormFactory
            groups={FieldsTomador(selected, lockForeign)}
            enbaleCountGroup
            onSubmit={async (values, actions) => {
              try {
                await handleSubmit(values, actions);
                actions.setSubmitting(false);
              } catch (error) {
                actions.setSubmitting(false);
              }
            }}
            button={{
              submit: "Incluir Dados de tomador na Nota",
              submitting: "Incluindo...",
              hide: false,
              backgroundColor: theme.colors.blue400,
            }}
          />
        </FormFactoryContainer>
      </Dialog>
      <Dialog
        header="Selecionar Tomador: "
        visible={!!showGrid}
        style={{ width: isSmallScreen ? "90vw" : "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => setShowGrid(false)}
      >
        <FormFactory
          groups={FilterFields(setParams)}
          enbaleCountGroup
          onSubmit={async (values, actions) => {
            try {
              console.warn(values, actions);
              actions.setSubmitting(false);
            } catch (error) {
              actions.setSubmitting(false);
            }
          }}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: true,
            onClick: () => history.goBack(),
          }}
          button={{
            submit: "Incluir Dados de tomador na Nota",
            submitting: "Incluindo...",
            hide: true,
            backgroundColor: theme.colors.darkBlue,
          }}
        />
        <CustomGrid>
          <div className="title-grid">Tomadores:</div>
          <DataGrid
            loading={!!loading}
            fields={fieldsGrid(setShow, setShowGrid, setSelected)}
            data={list?.content || []}
            onClickRow={(callback: TakerModel) => {
              setConfirm(callback);
            }}
            totalPages={list?.totalPages || 0}
            changePage={handlePage}
          />
        </CustomGrid>
      </Dialog>
      <ChooseModal
        text={`${confirm?.socialReason} é o seu tomador?`}
        onConfirm={async () => {
          setShowGrid(false);
          setShow(false);
          setCurrentNote((prev: any) => ({ ...prev, taker: confirm }));
          toastUtils.showMessage({
            type: "success",
            message: "Selecionado com Sucesso!",
          });
          setConfirm(null);
        }}
        onCancel={() => setConfirm(null)}
        isVisible={!!confirm}
        toggleVisibility={() => setConfirm(null)}
      />
    </div>
  );
};

export default TomadorComponent;
